// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  onClick?: (event) => void;
  size?: number;
  strokeColor?: string;
}
export const IconChevronDown: React.FC<Props> = ({
  onClick,
  size = 16,
  strokeColor = '#ffffff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M4 6L7.85858 9.85858C7.93668 9.93668 8.06332 9.93668 8.14142 9.85858L12 6"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
